import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import Styles from './AverageDurationCard.module.css'
import { Colors } from 'Theme'
import PropTypes from 'prop-types'
import { AnalyticsDataCard } from 'Components'
import AnalyticsSelectors from 'Stores/Analytics/Selectors'
import AnalyticsActions from 'Stores/Analytics/Actions'
import RequestState from 'Enums/RequestState'
import { useTranslation } from 'react-i18next'
import { formatMinutesToHours, formatNumber } from 'Utils/Calculations'

const AverageDurationCard = ({
  averageDuration,
  fetchAverageDuration,
  fetchAverageDurationRequestState,
  filter,
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    fetchAverageDuration(filter)
  }, [])
  useEffect(() => {
    fetchAverageDuration(filter)
  }, [filter])

  return (
    <div
      style={{
        backgroundColor: Colors.white,
      }}
      className={Styles.Card}
    >
      <AnalyticsDataCard
        title={t('Analytics.Ac')}
        subtitle={`${
          fetchAverageDurationRequestState === RequestState.LOADING ||
          fetchAverageDurationRequestState === RequestState.SUCCEEDED ||
          fetchAverageDurationRequestState === RequestState.UNINITIALIZED
            ? formatNumber(averageDuration?.data?.ac.totalCount)
            : '-'
        } ${t('Analytics.Transaction')}`}
        primaryValue={formatMinutesToHours(
          averageDuration?.data?.ac.averageDurationMinutes,
        )}
        body={`${t('Analytics.Minimum')} ${
          fetchAverageDurationRequestState === RequestState.LOADING ||
          fetchAverageDurationRequestState === RequestState.SUCCEEDED ||
          fetchAverageDurationRequestState === RequestState.UNINITIALIZED
            ? formatMinutesToHours(
                averageDuration?.data?.ac.shortestTransactionMinutes,
              )
            : '-'
        }, ${t('Analytics.Maximum')} ${
          fetchAverageDurationRequestState === RequestState.LOADING ||
          fetchAverageDurationRequestState === RequestState.SUCCEEDED ||
          fetchAverageDurationRequestState === RequestState.UNINITIALIZED
            ? formatMinutesToHours(
                averageDuration?.data?.ac.longestTransactionMinutes,
              )
            : '-'
        }`}
        isLoading={fetchAverageDurationRequestState === RequestState.LOADING}
        showDash={
          !(
            fetchAverageDurationRequestState === RequestState.LOADING ||
            fetchAverageDurationRequestState === RequestState.SUCCEEDED ||
            fetchAverageDurationRequestState == RequestState.UNINITIALIZED
          )
        }
      />

      <AnalyticsDataCard
        title={t('Analytics.Dc')}
        subtitle={`${
          fetchAverageDurationRequestState === RequestState.LOADING ||
          fetchAverageDurationRequestState === RequestState.SUCCEEDED ||
          fetchAverageDurationRequestState === RequestState.UNINITIALIZED
            ? formatNumber(averageDuration?.data?.dc.totalCount)
            : '-'
        } ${t('Analytics.Transaction')}`}
        primaryValue={formatMinutesToHours(
          averageDuration?.data?.dc.averageDurationMinutes,
        )}
        body={`${t('Analytics.Minimum')} ${
          fetchAverageDurationRequestState === RequestState.LOADING ||
          fetchAverageDurationRequestState === RequestState.SUCCEEDED ||
          fetchAverageDurationRequestState === RequestState.UNINITIALIZED
            ? formatMinutesToHours(
                averageDuration?.data?.dc.shortestTransactionMinutes,
              )
            : '-'
        }, ${t('Analytics.Maximum')} ${
          fetchAverageDurationRequestState === RequestState.LOADING ||
          fetchAverageDurationRequestState === RequestState.SUCCEEDED ||
          fetchAverageDurationRequestState === RequestState.UNINITIALIZED
            ? formatMinutesToHours(
                averageDuration?.data?.dc.longestTransactionMinutes,
              )
            : '-'
        }`}
        isLoading={fetchAverageDurationRequestState === RequestState.LOADING}
        showDash={
          !(
            fetchAverageDurationRequestState === RequestState.LOADING ||
            fetchAverageDurationRequestState === RequestState.SUCCEEDED ||
            fetchAverageDurationRequestState === RequestState.UNINITIALIZED
          )
        }
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  averageDuration: AnalyticsSelectors.getAverageDuration(state),
  fetchAverageDurationRequestState:
    AnalyticsSelectors.getFetchAverageDurationRequestState(state),
})
function mapDispatchToProps(dispatch) {
  return {
    fetchAverageDuration: (filter) =>
      dispatch(AnalyticsActions.fetchAverageDuration(filter)),
  }
}
AverageDurationCard.propTypes = {
  filter: PropTypes.object,
  averageDuration: PropTypes.object,
  fetchAverageDuration: PropTypes.func,
  fetchAverageDurationRequestState: PropTypes.number,
}

export default connect(mapStateToProps, mapDispatchToProps)(AverageDurationCard)
